import React from 'react';
import SandwichContainer from '../../../../components/sandwichContainer/sandwichContainer';
import SectionWrapper from '../../../../components/sectionWrapper/sectionWrapper';
import { PLATFORMS_LINE } from '../../constants';
import { styles } from './styles';

const QUESTIONS = [
  {
    question: 'Is PlayerCafe free?',
    answer: 'Yes. PlayerCafe is free, with ads. You can send 20 requests a day, and when you run out you can watch an ad for 10 more, up to twice a day. Passing on someone is always free.',
  },
  {
    question: 'Is it a dating app?',
    answer: 'No. PlayerCafe is for finding people to play games with. Profiles show your games, your gaming hours and a short bio, and that\'s what people connect over.',
  },
  {
    question: 'Who can join?',
    answer: 'You need to be 13 or older. In Settings, you can also choose which age range can see your profile.',
  },
  {
    question: 'Which platforms does it cover?',
    answer: `${PLATFORMS_LINE}. Turn on cross-platform in your filters to also see people who play your games on a different platform.`,
  },
  {
    question: 'What happens when I pass on someone?',
    answer: 'They leave your deck, and they aren\'t notified. You have five seconds to undo, and once you\'ve seen everyone you can reset your passes to see them again.',
  },
  {
    question: 'How do I report someone?',
    answer: 'Open the options on their card or in your chat with them, and choose Report User. You can also send us a message below with the topic Report someone.',
  },
  {
    question: 'How do I delete my account?',
    answer: 'In the app, open Settings and choose Delete Account. Deleting is permanent. If you\'d rather take a break, Disable Account hides you from everyone until you sign back in. If you can\'t get into the app, send us a message below with the topic Account help and we\'ll delete it for you.',
  },
];

export default function Faq(): JSX.Element {

  return (
    <SectionWrapper id="faq" label="Questions" heading="Frequently asked">
      <div style={styles.list}>
        {QUESTIONS.map((entry, index) => (
          <SandwichContainer key={entry.question} title={entry.question} isLast={index === QUESTIONS.length - 1}>
            <p style={styles.answer}>{entry.answer}</p>
          </SandwichContainer>
        ))}
      </div>
    </SectionWrapper>
  );

}
